import { useContext, useMemo } from "react";

import { selectMapZoom, selectWellLegendItems, useMapStore } from "stores/map";

import { DashboardContext } from "components/dashboard/contexts/DashboardContext";

import { canFetchEntitiesOnMapAtZoom } from "../utils/entitiesOnMapFetchPolicy";

export default function useShouldFetchEntitiesOnMap(): boolean {
  const zoom = useMapStore(selectMapZoom);
  const wellLegendItems = useMapStore(selectWellLegendItems);
  const { capabilities } = useContext(DashboardContext);

  return useMemo(() => {
    if (!capabilities?.hasMapWidget) {
      return true;
    }

    return canFetchEntitiesOnMapAtZoom({
      zoom,
      legendItems: wellLegendItems,
      capabilities
    });
  }, [capabilities, wellLegendItems, zoom]);
}
